import { render, staticRenderFns } from "./sizeChart.vue?vue&type=template&id=5a1da68b&scoped=true&"
import script from "./sizeChart.vue?vue&type=script&lang=js&"
export * from "./sizeChart.vue?vue&type=script&lang=js&"
import style0 from "./sizeChart.vue?vue&type=style&index=0&id=5a1da68b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1da68b",
  null
  
)

export default component.exports